import {
  CaretDownOutlined,
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Avatar, Col, Menu, Layout, Row, Typography, Button, Image, Popover } from 'antd';
import { Link } from 'react-router-dom';

import Config from '../app/config';
import logo from '../assets/logo.svg';
import { useHideLogoutSankhyaRh } from '../hooks/useHideLogoutSankhyaRh';
import useTypedNavigate from '../hooks/useTypedNavigate';
import useTypedParams from '../hooks/useTypedParams';
import { UserDetailSerializer } from '../types/api';
import styles from './Header.module.css';
import SideMenuButton from './SideMenuButton';

interface HeaderProps {
  user?: UserDetailSerializer;
  enableSideMenu?: boolean;
  enableSankhyaSideMenu?: boolean;
  configurationsPermissionChecker?: boolean;
}

const Header = ({
  user,
  enableSideMenu,
  enableSankhyaSideMenu,
  configurationsPermissionChecker,
}: HeaderProps) => {
  const { tenant } = useTypedParams({ tenant: String });

  const navigate = useTypedNavigate();

  const logout = `${
    process.env.REACT_APP_LOGIN_URL || window.location.origin
  }/${tenant}/api/logout/`;

  const { hideLogoutSankhyaRh } = useHideLogoutSankhyaRh(Config.REACT_APP_AUTH_DOMAIN || '');
  return (
    <Layout.Header
      className={[
        styles.header,
        ...(Config.REACT_APP_ENABLE_MINDSTEM_STYLES === 'true' ? [styles.headerGradient] : []),
      ].join(' ')}
    >
      <Row align="middle" className={styles.row}>
        {enableSideMenu && !enableSankhyaSideMenu && (
          <Col>
            <SideMenuButton />
          </Col>
        )}
        <Col>
          <Typography.Title level={2} className={styles.title}>
            <Image
              className={styles.logo}
              width={40}
              src={`${Config.REACT_APP_STATIC_URL}${logo}`}
              preview={false}
              onClick={() => navigate({ pathname: '/:tenant/opportunities/', params: { tenant } })}
            />
            Recrutamento e Seleção
          </Typography.Title>
        </Col>
        <Col flex="auto" />
        <Col>
          <Popover
            title={
              <>
                <Typography.Text style={{ color: '#737380' }}>
                  {user?.full_name || user?.username}
                </Typography.Text>
                <br />
                <Typography.Text strong style={{ color: '#166889' }}>
                  {user?.email}
                </Typography.Text>
              </>
            }
            placement="bottomRight"
            className={styles.popover}
            overlayClassName={styles.popoverContent}
            content={
              <>
                <Menu
                  selectable={false}
                  items={[
                    ...(configurationsPermissionChecker
                      ? [
                          {
                            key: 'settings',
                            icon: <SettingOutlined />,
                            label: <Link to="settings">Configurações</Link>,
                          },
                        ]
                      : []),
                  ]}
                />
                {!hideLogoutSankhyaRh && (
                  <div className={styles.btnContainer}>
                    <a rel="noopener noreferrer" href={logout}>
                      <Button icon={<LogoutOutlined />} style={{ width: '100%' }}>
                        Sair
                      </Button>
                    </a>
                  </div>
                )}
              </>
            }
          >
            <Button type="text" data-testid="profile-popover">
              <Avatar size="small" icon={<UserOutlined />} />
              <CaretDownOutlined />
            </Button>
          </Popover>
        </Col>
      </Row>
    </Layout.Header>
  );
};

export default Header;
